// extracted by mini-css-extract-plugin
export default {"senderNameInformation":"change-sender-name_senderNameInformation__AcS+o","firstName":"change-sender-name_firstName__3SVmz"};